import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import AddRoleModal from "../components/AddRoleModal";
import { all_routes } from "../../../router/all_routes";
import PageHeader from "../../../../core/common/crmComponents/PageHeader";
import { useRolesData } from "../hooks/useRolesData";
import HasPermission from "../../../../core/common/wrapper/HasPermission";
import LoaderComponent from "../../../../core/common/crmComponents/LoaderComponent";
import {
  MODULES,
  MODULES_ACTIONS,
} from "../../../../core/data/constants/moduleConstants";
import { IoIosArrowRoundBack } from "react-icons/io";
import { Menu, MenuItem, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { convertToUTCString } from "../../../../utils/helpers/helper";
import EditRoleModal from "../components/EditRoleModal";

const RolesPermissions = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useRolesData();
  const dataSource = data?.data?.data || [];

  // State for action menu
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);

  const handleMenuOpen = (event, role) => {
    setAnchorEl(event.currentTarget);
    setSelectedRole(role);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRole(null);
  };

  const columns = [
    {
      field: "name",
      headerName: "Role Name",
      flex: 1,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params.value.split("-").join(" ")}
        </div>
      ),
    },
    {
      field: "parentRole",
      headerName: "Reports To",
      flex: 1,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params.row?.parentRole?.name?.split("-").join(" ")}
        </div>
      ),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1.4,
      renderCell: (params) => (
        <div>
          {params?.row.createdAt
            ? convertToUTCString(params?.row?.createdAt)
            : convertToUTCString(params?.row?.updatedAt)}
        </div>
      ),
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 1.4,
      renderCell: (params) => (
        <div>
          {params?.row?.updatedAt
            ? convertToUTCString(params?.row?.updatedAt)
            : convertToUTCString(params?.row?.createdAt)}
        </div>
      ),
    },

    {
      field: "action",
      headerName: "Action",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton onClick={(event) => handleMenuOpen(event, params.row)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl && selectedRole?.id === params.row.id)}
            onClose={handleMenuClose}
          >
            <MenuItem
              component={Link}
              to={route.permissions}
              state={{
                controls: selectedRole?.control || {},
                readVisibility: selectedRole?.readVisibility || {},
                id: selectedRole?._id,
                name: selectedRole?.name,
                functionalityAccess: selectedRole?.functionalityAccess || {},
              }}
              onClick={handleMenuClose}
            >
              <i className="ti ti-shield text-success me-2" />
              Permission
            </MenuItem>
            <MenuItem
              component={Link}
              data-bs-toggle="modal"
              data-bs-target="#edit_role"
              onClick={(event) => {
                event.preventDefault();
                setTimeout(() => setSelectedRole(params.row), 0);
                handleMenuClose();
              }}
            >
              <i className="ti ti-edit text-success me-2" />
              Edit Role
            </MenuItem>
          </Menu>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <PageHeader pageName="Roles" moduleName={MODULES.ROLES}>
                <button
                  className="p-2 btn btn-outline-none"
                  onClick={() => navigate(all_routes.settings)}
                >
                  <IoIosArrowRoundBack className="d-inline" size={20} />
                </button>
              </PageHeader>
              <div className="card">
                <div className="card-header d-flex justify-content-between">
                  <HasPermission
                    module={MODULES.ROLES}
                    action={MODULES_ACTIONS.CREATE}
                  >
                    <Link
                      to="#"
                      className="btn btn-primary ms-auto"
                      data-bs-toggle="modal"
                      data-bs-target="#add_role"
                    >
                      <i className="ti ti-square-rounded-plus me-2" />
                      Add New Roles
                    </Link>
                  </HasPermission>
                </div>
                <div className="card-body">
                  {isLoading ? (
                    <LoaderComponent />
                  ) : isError ? (
                    <div>Error: {error?.message}</div>
                  ) : (
                    <div style={{ width: "100%" }}>
                      <DataGrid
                        rows={dataSource}
                        columns={columns.map((column) => ({
                          ...column,
                          headerClassName: "bg-light-200",
                        }))}
                        pageSize={5}
                        rowsPerPageOptions={[5, 10, 20]}
                        getRowId={(row) => row?._id}
                        autoHeight
                        hideFooter
                        disableSelectionOnClick
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddRoleModal />
      <EditRoleModal role={selectedRole} />
    </>
  );
};

export default RolesPermissions;
